/**
 * Formatea un valor de campo de auditoría para mostrar en la UI.
 *
 * - `null`, `undefined` o string vacío → `"(vacío)"`
 * - `"true"` o `true` → `"Sí"`
 * - `"false"` o `false` → `"No"`
 * - cualquier otro valor → string tal cual
 */
export function formatAuditValue(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '(vacío)';
  if (value === 'true' || (value as unknown) === true) return 'Sí';
  if (value === 'false' || (value as unknown) === false) return 'No';
  return value;
}

/**
 * Retorna true si el valor formateado representa un estado vacío.
 * Útil para aplicar estilos de cursiva/muted.
 */
export function isEmptyAuditValue(value: string | null | undefined): boolean {
  return value === null || value === undefined || value === '';
}
